import React from 'react';

import { Link, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Invoice() {
  const { t, i18n } = useTranslation();
  return (
    <>
      <div className='container-fluid'>
        <div className='shadow m-3 p-2'>
          <div className='row my-2 mx-2'>
            <span
              className={`${
                i18n.language === 'en' ? 'me-3 text-end order-1' : 'ms-3 text-start order-2'
              } col-2 fs-4 text-decoration-underline`}
              style={{ textUnderlineOffset: '10px' }}>
              <span>{t('document.title')}</span>
            </span>
            <nav className={`${i18n.language === 'en' ? 'order-2' : 'order-1'} col`}>
              <div
                className={`${
                  i18n.language === 'en' ? '' : 'd-flex flex-row-reverse'
                } nav nav-pills`}
                id='nav-tab'
                role='tablist'>
                <Link
                  className='nav-item nav-link text-decoration-none mx-1'
                  id='nav-all-tab'
                  data-toggle='pill'
                  to={'all'}
                  role='tab'
                  aria-controls='nav-all'
                  aria-selected='true'>
                  {t('document.navbar.all')}
                </Link>
                <Link
                  className='nav-item nav-link text-decoration-none mx-1'
                  id='nav-submitted-tab'
                  data-toggle='pill'
                  to={'submitted'}
                  role='tab'
                  aria-controls='nav-submitted'
                  aria-selected='true'>
                  {t('document.navbar.submitted')}
                </Link>
                <Link
                  className='nav-item nav-link text-decoration-none mx-1'
                  id='nav-received-tab'
                  data-toggle='pill'
                  to={'received'}
                  role='tab'
                  aria-controls='nav-received'
                  aria-selected='false'>
                  {t('document.navbar.received')}
                </Link>
                <Link
                  className='nav-item nav-link text-decoration-none mx-1'
                  id='nav-search-portal-tab'
                  data-toggle='pill'
                  to={'searchPortal'}
                  role='tab'
                  aria-controls='nav-search-portal'
                  aria-selected='false'>
                  {t('document.navbar.etaSearch')}
                </Link>
                <Link
                  className='nav-item nav-link text-decoration-none mx-1'
                  id='nav-search-sobol-tab'
                  data-toggle='pill'
                  to={'searchSobol'}
                  role='tab'
                  aria-controls='nav-search-sobol'
                  aria-selected='false'>
                  {t('document.navbar.sobolSearch')}
                </Link>
              </div>
            </nav>
            <div className='tab-content' id='nav-tabContent'>
              <div
                className='tab-pane fade show active'
                id='nav-all'
                role='tabpanel'
                aria-labelledby='nav-all-tab'></div>
              <div
                className='tab-pane fade'
                id='nav-submitted'
                role='tabpanel'
                aria-labelledby='nav-submitted-tab'></div>
              <div
                className='tab-pane fade'
                id='nav-received'
                role='tabpanel'
                aria-labelledby='nav-received-tab'></div>
              <div
                className='tab-pane fade'
                id='nav-search-portal-tab'
                role='tabpanel'
                aria-labelledby='nav-search-portal-tab'></div>
              <div
                className='tab-pane fade'
                id='nav-search-sobol-tab'
                role='tabpanel'
                aria-labelledby='nav-search-sobol-tab'></div>
            </div>
          </div>
          <Outlet />
        </div>
      </div>
    </>
  );
}

export default Invoice;
